import LanguageSelector from './LanguageSelector/language-selector.component';
import ThemeSelector from './ThemeSelector/theme-selector.component';
import { Container, Copyright, Wrapper } from './footer.styles';

const RegisterFooter = () => {
  return (
    <Wrapper>
      <Container>
        <ThemeSelector />
        <LanguageSelector />
      </Container>
      <a href="https://www.abbiamolog.com/home" target="_blank" rel="noreferrer">
        <Copyright>Copyright - Abbiamo {new Date().getFullYear()}</Copyright>
      </a>
    </Wrapper>
  );
};

export default RegisterFooter;
